/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Location_TeamInputs */



/**
* | output |
* | --- |
* | "Team" |
*
* @param {Explorer_Search_Location_TeamInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_location_team = /** @type {((inputs?: Explorer_Search_Location_TeamInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Location_TeamInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Team")
	if (locale === "de") return /** @type {LocalizedString} */ ("Team")
	if (locale === "it") return /** @type {LocalizedString} */ ("Team")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Team")
	if (locale === "es") return /** @type {LocalizedString} */ ("Team")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Team")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Team")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Team")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Team")
	return /** @type {LocalizedString} */ ("Team")
});